import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "bank" }
const _hoisted_3 = {
  href: "https://bank.gov.ua/ua/open-data/api-dev",
  title: "In more detail...",
  target: "_blank"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "creep3d" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrentDate = _resolveComponent("CurrentDate")!
  const _component_NBURatesCreep3d = _resolveComponent("NBURatesCreep3d")!
  const _component_NBURatesCreepJS = _resolveComponent("NBURatesCreepJS")!
  const _component_NBURates = _resolveComponent("NBURates")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('project1.name')), 1),
    _cache[8] || (_cache[8] = _createElementVNode("line", null, null, -1)),
    _createVNode(_component_CurrentDate),
    _createElementVNode("h1", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('nbu')), 1),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createElementVNode("i", {
        title: [_ctx.tableView ? 'Start viewing in List view' : 'Start viewing in Table view'],
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeView && _ctx.changeView(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fa', _ctx.tableView ? 'fa-list' : 'fa-th'])
        }, null, 2)
      ], 8, _hoisted_4),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createElementVNode("i", {
        title: [_ctx.cripView3d ? 'Close 3D Creeping line' : 'Start 3D Creeping line'],
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeCrip3d && _ctx.changeCrip3d(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fa', _ctx.cripView3d ? 'fa-yin-yang' : 'fa-sack-dollar'])
        }, null, 2)
      ], 8, _hoisted_5),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("i", {
        title: [_ctx.cripView ? 'Close Creeping line' : 'Start Creeping line'],
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeCrip && _ctx.changeCrip(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(['fa', _ctx.cripView ? 'fa-face-grin-stars' : 'fa-wallet'])
        }, null, 2)
      ], 8, _hoisted_6),
      _cache[7] || (_cache[7] = _createTextVNode()),
      _withDirectives(_createElementVNode("input", {
        title: "Changing speed of Creeping line",
        type: "range",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.speed) = $event)),
        min: "0",
        max: "6",
        step: "0.2"
      }, null, 512), [
        [_vShow, _ctx.cripView],
        [
          _vModelText,
          _ctx.speed,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_NBURatesCreep3d, { "crip-view3d": _ctx.cripView3d }, null, 8, ["crip-view3d"])
    ]),
    _createVNode(_component_NBURatesCreepJS, {
      class: "creep",
      "crip-view": _ctx.cripView,
      speed: _ctx.speed
    }, null, 8, ["crip-view", "speed"]),
    _createVNode(_component_NBURates, { "table-view": _ctx.tableView }, null, 8, ["table-view"])
  ]))
}